import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import {AlertMessage, AlertService} from "../../services/alert.service";


@Component({
  selector: 'alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  animations: [
    trigger('myInsertRemoveTrigger', [
      transition(':enter', [
        style({ transform: 'translateY(100%)' }),
        animate('300ms', style({ transform: 'translateY(0%)' }))
      ]),
      transition(':leave', [animate('300ms', style({ transform: 'translateY(100%)' }))])
    ])
  ]
})
export class AlertComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  messages: AlertMessage[];

  constructor(private alertService: AlertService) {}

  ngOnInit(): void {
    this.subscription = this.alertService.getMessage().subscribe(message => {
      this.messages = message;
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  }
}
